import React, { useState } from "react";
import Modal from "../../../../components/Reusable/Modal";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import {
  deleteAirtimeCategory,
  fetchAirtimeCategories,
} from "../../../../features/auth/store/airtimeCategorySlice";
import { toast } from "react-toastify";
import { DeleteModalProps } from "../types";
import { RootState } from "../../../../redux/store";
export const DeleteAirtimeCategoryModal: React.FC<DeleteModalProps> = ({
  id: categoryId,
  isOpen,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const { currentPage } = useAppSelector(
    (state: RootState) => state.airtimeCategories,
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (categoryId === null) return;
    setIsSubmitting(true);
    try {
      await dispatch(deleteAirtimeCategory(categoryId)).unwrap();
      toast.success("Airtime Category deleted successfully! 🚀");
      onClose();
      dispatch(fetchAirtimeCategories({ page: currentPage }));
    } catch (err: any) {
      toast.error(err?.message || "Failed to delete category");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="text-xl font-bold mb-4">Delete Airtime Category</h2>
      <div className="p-4">
        <p>Are you sure you want to delete this airtime category?</p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};
